import * as ResultsAward from './resultsAward.js';
export default ResultsAward;
